import type { RovoConfiguration } from '@jira/ai-rovo_actions-shared-types/src/RovoConfiguration.types.tsx';
import { useAiRovoCurrentRouteConfigurationStore } from './aiRovoCurrentRouteConfigurationStore.tsx';

export const useAiRovoCurrentRouteConfiguration = (): RovoConfiguration => {
	const configuration = useAiRovoCurrentRouteConfigurationStore((state) => state.configuration);
	return configuration;
};
